const UibDatepickerPopupConfig = ['uibDatepickerPopupConfig', function(uibDatepickerPopupConfig) {
    uibDatepickerPopupConfig.showButtonBar = false;
}];
export default UibDatepickerPopupConfig;